var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 5.55625 5.55625",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.264583,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "path1220",
    cx: 2.778125,
    cy: 2.778125,
    r: 2.6458333
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "i",
    id: "text9012",
    style: {
      fontWeight: "bold",
      fontSize: "4.93889px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "middle",
      fill: "#ffffff",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 0.264583,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect26081",
    width: 0.529167,
    height: 0.529167,
    x: 2.5135415,
    y: 1.4552082,
    ry: 0.13229166,
    rx: 0.13229166
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 0.264583,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect26081-0",
    width: 0.52916664,
    height: 1.5875,
    x: 2.5135419,
    y: 2.5135415,
    ry: 0.13229166,
    rx: 0.13229166
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.2e5785fc3462080f8c37ad8c7d53784b.svg";
export { ForwardRef as ReactComponent };